<template>
  <toggle-section
    section="TopBusinessRecord"
    chevron-position="right"
    :has-padding="false"
    :is-open="openedArticles['TopBusinessRecord']"
    @toggle="$emit('toggle', 'TopBusinessRecord')"
  >
    <template #titleSection>
      <div class="flex items-center justify-start space-x-2">
        <lf-h4>
          {{ $t("DEALS.LEXIS_NEXIS.BUSINESS_CREDIT.TOP_BUSINESS_RECORD") }}
        </lf-h4>
        <counter-pill class="h-6 w-6" :count="count" :color="COLORS[9]" />
      </div>
    </template>
    <template #content>
      <div class="space-y-6 p-6">
        <toggle-section
          v-for="(record, key) in businessRecord"
          :key="`topBusinessRecords_${key}`"
          :section="key"
          chevron-position="right"
          :has-padding="false"
          :is-open="openedArticles[key]"
          :data-cy="key"
          @toggle="$emit('toggle', key)"
        >
          <template #titleSection>
            <lf-h4>
              {{ startCase(camelCase(key)) }}
            </lf-h4>
          </template>
          <template #content>
            <div class="grid grid-cols-2 py-4">
              <template v-for="(value, subKey) in record" :key="subKey">
                <div
                  class="grid grid-cols-2 justify-between odd:border-r"
                  :class="{ 'px-4 py-2': typeof value !== 'object' }"
                >
                  <template v-if="typeof value === 'object'">
                    <div
                      class="col-span-2 px-4 py-2 font-semibold text-headline"
                    >
                      {{ startCase(camelCase(subKey)) }}:
                    </div>
                    <template
                      v-for="(subValue, subSubKey) in value"
                      :key="subSubKey"
                    >
                      <div class="px-4 py-2">
                        {{ startCase(camelCase(String(subSubKey))) }}
                      </div>
                      <div class="px-4 py-2 text-right text-headline">
                        {{ subValue }}
                      </div>
                    </template>
                  </template>
                  <template v-else>
                    <div>{{ startCase(camelCase(subKey)) }}</div>
                    <div class="text-right text-headline">
                      {{ value }}
                    </div>
                  </template>
                </div>
              </template>
            </div>
          </template>
        </toggle-section>
      </div>
    </template>
  </toggle-section>
</template>

<script setup lang="ts">
import camelCase from "lodash/camelCase";
import startCase from "lodash/startCase";

import { COLORS } from "@/helpers/constants";

import CounterPill from "@/components/CounterPill.vue";
import ToggleSection from "@/components/ToggleSection.vue";

import type { TopBusinessRecord } from "@/models/commercialData/lexisnexis/LexisNexisSmallBusinessBlendedCreditScore";

defineEmits(["toggle"]);
defineProps<{
  businessRecord: TopBusinessRecord;
  count: number;
  openedArticles: Record<string, boolean>;
}>();
</script>
